export default "/images/aperture.svg?09da64237cef340d981a3cb3615e1308";